import { IFilterSettings } from "Domain/Repository/BaseRepository/BaseRepository";

export const FIND_FILE_REFERENCES_REQUEST = 'FIND_FILE_REFERENCES_REQUEST';

export const findFileReferencesRequest = ({
     filter = [],
     sorting = { field: 'id', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }: IFilterSettings ) => ({
    type: FIND_FILE_REFERENCES_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
    }
});
